let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5gyXd")).then(() => parcelRequire('agp1B'));